<app-header></app-header>
<div class="row w-100 h-100 mx-0 auth-page">
  <div class="col-md-4 col-xl-4 mx-auto quote">
    <login-quote></login-quote>
  </div>
  <div class="col-md-4 col-xl-4 mx-auto container">
    <div class="card p-3 h-100">
      <div class="m-auto auth-form-wrapper">
        <div class="py-5">
          <h4 class="login-title">{{ 'AUTH.LOGIN_TITLE' | translate }}</h4>
        </div>
        <form class="forms-sample" [formGroup]="loginForm" [markRequired]="loginForm">
          <div class="form-group">
            <label for="exampleInputEmail1">{{ 'AUTH.EMAIL' | translate | titlecase}}</label>
            <extended-input [inputControl]="loginForm.get('email')">
              <input type="email"
                  class="form-control"
                  id="exampleInputEmail1"
                  formControlName="email"
                  placeholder="{{ 'AUTH.PLACEHOLDER_PRE' | translate }} {{ 'AUTH.EMAIL' | translate }}">
            </extended-input>
          </div>
          <div class="form-group">
            <label for="exampleInputPassword1">{{ 'AUTH.PASSWORD' | translate | titlecase}}</label>
            <extended-input [inputControl]="loginForm.get('password')">
              <input type="password"
                  class="form-control"
                  id="exampleInputPassword1"
                  formControlName="password"
                  autocomplete="current-password"
                  placeholder="{{ 'AUTH.PLACEHOLDER_PRE' | translate }} {{ 'AUTH.PASSWORD' | translate }}">
            </extended-input>
          </div>
          <div class="mt-3">
            <button type="submit"
              class="btn btn-primary ml-2 mb-2 mb-md-0 w-100 submit-btn"
              [disabled]="!loginForm.valid"
              (click)="login()">
              {{ 'AUTH.LOGIN' | translate }}
            </button>
          </div>
          <div class="mt-3 social-login">
            <div class="separator">
              <hr/>
              <span class="login-with-title">
                {{ 'AUTH.LOGIN_WITH' | translate }}
              </span>
            </div>
            <div class="col-sm-12 my-auto social-buttons">
              <!--change to google logo-->
              <img src="assets/images/google-logo.png"
                  alt="Google"
                  class="auth-button google-sign-in"
                  auth="sign-in-with-google"
                  (click)="signInWithGoogle()">
              <!--change to facebook logo-->
              <img src="assets/images/facebook-logo.png"
                  alt="Facebook"
                  class="auth-button facebook-sign-in"
                  auth="sign-in-with-facebook"
                  (click)="signInWithFacebook()">
            </div>
          </div>
          <div class="col-12 d-flex justify-content-center">
            <a routerLink="/forgotPassword" class="d-block mt-3">{{ 'AUTH.FORGOT_PASSWORD' | translate }}</a>
          </div>
          <div class="col-12 d-flex justify-content-center">
            <a routerLink="/register" class="d-block mt-3 text-muted">{{ 'AUTH.NOT_USER' | translate }}</a>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
